import { render, staticRenderFns } from "./ArrayedEmailField.vue?vue&type=template&id=38c0fdb4&"
import script from "./ArrayedEmailField.vue?vue&type=script&lang=js&"
export * from "./ArrayedEmailField.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports